import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

interface EditPlanField {
    field_id: string;
    field_label: string;
    value: string;
}

interface EditPlanPayload {
    planId: string;
    fields: EditPlanField[];
}

const editPlan = async ({ planId, fields }: EditPlanPayload) => {
    const token = localStorage.getItem('accessToken');
    const currentUser = localStorage.getItem('email');
    const response = await axios(tpoGenUrls.updatePlan(planId), {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: {
            fields,
            updated_by: currentUser,
        },
    });

    if (response?.data?.plan_edit_status === 'failed') {
        throw new Error(response?.data?.error_message);
    }

    return response.data;
};

const useEditPlanMutation = ({ onSuccess }: { onSuccess?: () => void }) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (data: EditPlanPayload) => editPlan(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.planningGroups() });
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'plan-list'] });
            sendNotification('success', 'Plan updated successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message = error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Failed to update plan';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useEditPlanMutation;
